import { useState } from 'react';
import FormInput from './FormInput';
import { isValidEmail, isValidPassword, isValidWhatsApp } from '../../services/supabase';

const RegisterForm = ({ onSubmit, loading }) => {
    const [formData, setFormData] = useState({
        fullName: '',
        email: '',
        whatsapp: '',
        password: ''
    });
    const [error, setError] = useState('');

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
        setError('');
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');

        // Mantendo todas as validações originais
        if (!formData.fullName.trim()) {
            setError('Nome completo é obrigatório');
            return;
        }

        if (!isValidEmail(formData.email)) {
            setError('E-mail inválido');
            return;
        }

        if (!isValidWhatsApp(formData.whatsapp)) {
            setError('WhatsApp inválido. Use apenas números (10 ou 11 dígitos)');
            return;
        }

        if (!isValidPassword(formData.password)) {
            setError('A senha deve ter pelo menos 8 caracteres');
            return;
        }

        onSubmit(formData);
    };

    return (
        <form onSubmit={handleSubmit} className="space-y-6">
            {error && (
                <div className="bg-red-50 text-error text-sm p-3 rounded-md">
                    {error}
                </div>
            )}

            <FormInput
                id="fullName"
                name="fullName"
                type="text"
                required
                placeholder="Seu nome completo"
                value={formData.fullName}
                onChange={handleChange}
                disabled={loading}
                label="Nome Completo"
            />

            <FormInput
                id="email"
                name="email"
                type="email"
                required
                placeholder="Seu melhor e-mail"
                value={formData.email}
                onChange={handleChange}
                disabled={loading}
                label="E-mail"
            />

            <FormInput
                id="whatsapp"
                name="whatsapp"
                type="tel"
                required
                placeholder="Seu WhatsApp (apenas números)"
                value={formData.whatsapp}
                onChange={handleChange}
                disabled={loading}
                label="WhatsApp"
            />

            <FormInput
                id="password"
                name="password"
                type="password"
                required
                placeholder="Crie uma senha forte"
                value={formData.password}
                onChange={handleChange}
                disabled={loading}
                label="Senha"
            />

            <button
                type="submit"
                disabled={loading}
                className="w-full py-3 px-4 bg-accent text-white font-medium rounded-md hover:bg-accent-dark focus:outline-none focus:ring-2 focus:ring-accent-dark focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
            >
                {loading ? 'Criando conta...' : 'Criar conta'}
            </button>
        </form>
    );
};

export default RegisterForm;
